module.exports = __webpack_public_path__ + "img/17.baed450e.svg";